<template>
    <!--currently service does not return a image url-->
    <div>
      <hp5-person-image
        :src="result.photoUrl ? result.photoUrl : null"
        image-alt=""
        background-image="/content/dam/brand-identity/backgrounds/headshot-background-240x240.jpg"
        doctor
        size-lg="sm"
        size-md="sm"
        size-sm="xs"
        size-xs="xs"
      />
    </div>
</template>
<script setup>

    const props = defineProps({
        result: Object
    })

</script>